// extracted by mini-css-extract-plugin
export default {"chart-1":"Reports_chart-1__Ftp9k","table-td":"Reports_table-td__TCjbZ"};